export default [
  {
    id: 1,
    value: 'FEMALE',
    label: 'Female',
  },
  {
    id: 2,
    value: 'MALE',
    label: 'Male',
  },
  {
    id: 3,
    value: 'OTHER',
    label: 'Other',
  },
  {
    id: 4,
    value: 'PREFER_NOT_TO_SAY',
    label: 'Prefer not to specify',
  },
];
